export default "network:\n  host: 0.0.0.0\nhttp:\n  port: $mainPort\n\ncluster:\n  name: $name\n\n# Data Paths\npath:\n  logs: /data/log\n  data: /data/data\n";